import React, { FC } from 'react';

import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';

import Redirect from './Redirect';

type RegexRedirectProps = {
  pattern: RegExp;
  toGenerator: (match: RegExpMatchArray) => string;
};

const RegexRedirect: FC<RegexRedirectProps> = ({ pattern, toGenerator }) => {
  const location = useLocation();

  const match = location.pathname.match(pattern);

  if (!match) {
    return null;
  }

  const redirectTo = toGenerator(match);

  return <Redirect from={location.pathname} to={redirectTo} />;
};

RegexRedirect.propTypes = {
  /** regex pattern to match against the current path */
  pattern: PropTypes.instanceOf(RegExp).isRequired,
  /** function that generates the redirect path based on regex match */
  toGenerator: PropTypes.func.isRequired,
};

export default RegexRedirect;
